import type { CaptchaAnswer, CaptchaChallenge, GeoLocation, QueueAccessCheck, QueueAccessSettings } from '../types';
import { apiService } from './apiService';

class QueueAccessService {
  /** @param locationError why no location could be read, if so (logged by the server) */
  check(shift?: number, location?: GeoLocation | null, locationError?: string): Promise<QueueAccessCheck> {
    return apiService.post<QueueAccessCheck>('/queue-access/check', { shift, location: location ?? undefined, locationError });
  }

  getChallenge(): Promise<CaptchaChallenge> {
    return apiService.post<CaptchaChallenge>('/captcha/challenge');
  }

  async verify(challengeId: string, answer: CaptchaAnswer): Promise<string> {
    const response = await apiService.post<{ passToken: string }>('/captcha/verify', { challengeId, answer });
    return response.passToken;
  }

  getAdminSettings(): Promise<QueueAccessSettings> {
    return apiService.get<QueueAccessSettings>('/admin/settings/queue-access');
  }

  updateAdminSettings(settings: QueueAccessSettings): Promise<QueueAccessSettings> {
    return apiService.post<QueueAccessSettings>('/admin/settings/queue-access', settings);
  }
}

export const queueAccessService = new QueueAccessService();
